/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable object-curly-spacing */
/* eslint-disable quotes */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
/* eslint-disable lines-between-class-members */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from "react";
import "../../css/pages/gettingstarted.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SideNav from "../components/SideNav";
import TopNav from "../components/TopNav";
import iconSprite from "../../assets/icon-sprite.svg";
import OnboardInfo from "../components/modals/OnboardInfo";
import OnboardDocs from "../components/modals/OnboardDocs";
import AxiosClient from "../utils/AxiosClient";
import {
  fetchBusiness,
  fetchBankAccounts,
  fillUser,
  updateBusiness,
} from "../actions/account";
import { getBanks } from "../actions/utils";
import OnboardBankAccount from "../components/modals/OnboardBankAccount";
import Pin from "../components/modals/Pin";
// import OnboardInsurance from "../components/modals/OnboardInsurance";

class GettingStarted extends Component {
  constructor(props) {
    super(props);
    this.state = { progress: 0 };
  }

  componentDidMount() {
    // const { business, fetchBusiness, user } = this.props;

    this.props.getBanks();
    AxiosClient().then((client) => {
      client
        .get("/settings/document/types")
        .then(({ data: { data: types } }) => {
          this.setState({ types });
          // this.setState((prevState) => ({
          //   progress: Math.min(
          //     Math.ceil((prevState.progress / (3 + types.length)) * 100),
          //     100,
          //   ),
          //   //  prevState.progress + 1,
          // }));
        });
    });
    this.fetchDocs();
    this.fetchAccounts();

    // if (business.registration_number && business.registration_date) {
    //   this.setState((prevState) => ({
    //     progress: prevState.progress + 1,
    //   }));
    // }

    // if (user.pin) {
    //   this.setState((prevState) => ({
    //     progress: prevState.progress + 1,
    //   }));
    // }

    // const { progress } = this.state;
    // if (progress === 100) {
    //   console.log("retrosp");
    //   const r = setInterval(() => {
    //     (async function fetchBusinessUpdate() {
    //       await fetchBusiness();
    //     }());

    //     if (business.status === "active") {
    //       console.log(business, "active");
    //     } else {
    //       console.log(business, "inactive");
    //     }
    //   }, 5000);
    // }
  }

  // componentWillUnmount() {
  //   clearInterval(intervalId);
  // }

  fetchDocs = async () => {
    const client = await AxiosClient();
    const {
      data: { data: documents },
    } = await client.get("/settings/document");
    this.setState({ documents });
    // this.setState((prevState) => ({
    //   progress: Number(prevState.progress) + documents.length,
    // }));
  };

  fetchAccounts = async () => {
    fetchBankAccounts()
      .then(({ data: bank_accounts }) => {
        console.log({ bank_accounts });
        this.setState({ bank_accounts });
        // this.setState((prevState) => ({
        //   progress: bank_accounts[0]
        //     ? prevState.progress + 1
        //     : prevState.progress,
        // }));
      })
      .catch(console.error);
  };

  render() {
    const {
      info,
      doc,
      bank,
      types = [],
      documents = [],
      bank_accounts,
      pin,
      // progress,
    } = this.state;
    const { user, business } = this.props;
    let progress = 0;
    if (business.registration_number && business.registration_date) {
      progress += 1;
    }
    if (bank_accounts?.[0]) progress += 1;
    if (user.pin) progress += 1;

    progress += documents.length;
    progress = Math.min(Math.ceil((progress / (3 + types.length)) * 100), 100);

    return (
      <>
        <SideNav />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav />
            <section className="body-main__content">
              <div className="getting">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">
                    Hello,
                    {business?.name}
                  </h3>
                  <p className="pageTitle__subheader">Welcome back!</p>
                </div>
              </div>
              <div className="dashboardProfileSet">
                <div className="dashboardProfileSet__banner">
                  <div className="dashboardProfileSet__banner--content">
                    <div className="dashboardProfileSet__banner--textwrapper">
                      <div className="dashboardProfileSet__banner--progress">
                        <div className="progress--dough">
                          <span>{progress}%</span>
                          <svg className="" viewBox="0 0 108 108">
                            <circle
                              style={{
                                strokeDashoffset: 327 - (progress / 100) * 327,
                              }}
                              transform="rotate(-90 54 54)"
                              strokeDasharray="327"
                              cx="54"
                              cy="54"
                              r="52"
                              fill="transparent"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="dashboardProfileSet__banner--text">
                        <h3>
                          {progress === 100
                            ? "Profile is complete"
                            : "Complete your profile."}
                        </h3>
                        <p>
                          {progress === 100
                            ? "Your account is under review."
                            : "You’re on track. Complete your profile to fully utilize your account."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dashboardProfileSet__steps">
                  <div className="dashboardProfileSet__steps--content">
                    <div className="steps">
                      <div className="step">
                        <Link
                          className="text-decoration-none"
                          to="#"
                          onClick={() => this.setState({ info: true })}
                        >
                          Add business/broker info
                          <span>
                            <svg
                              width="24"
                              height="24"
                              hidden={
                                !business.registration_number ||
                                !business.registration_date
                              }
                            >
                              <use xlinkHref={iconSprite + "#done"}></use>
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              hidden={
                                business.registration_number &&
                                business.registration_date
                              }
                            >
                              <use xlinkHref={iconSprite + "#chevron"}></use>
                            </svg>
                          </span>
                        </Link>
                      </div>
                      <div className="step">
                        <Link
                          className="text-decoration-none"
                          to="#"
                          onClick={() => this.setState({ bank: true })}
                        >
                          Add business/broker bank account details
                          <span>
                            <svg
                              width="24"
                              height="24"
                              hidden={!bank_accounts?.[0]}
                            >
                              <use xlinkHref={iconSprite + "#done"}></use>
                            </svg>
                            <svg
                              width="24"
                              height="24"
                              hidden={bank_accounts?.[0]}
                            >
                              <use xlinkHref={iconSprite + "#chevron"}></use>
                            </svg>
                          </span>
                        </Link>
                      </div>

                      {types.map((type) => (
                        <div className="step" key={type.id}>
                          <Link
                            className="text-decoration-none"
                            to="#"
                            onClick={() => this.setState({ doc: type })}
                          >
                            Upload your {type.code_description}
                            <span>
                              <svg
                                width="24"
                                height="24"
                                hidden={
                                  !documents.find((x) => x.type_id === type.id)
                                }
                              >
                                <use xlinkHref={iconSprite + "#done"}></use>
                              </svg>
                              <svg
                                width="24"
                                height="24"
                                hidden={
                                  !!documents.find((x) => x.type_id === type.id)
                                }
                              >
                                <use xlinkHref={iconSprite + "#chevron"}></use>
                              </svg>
                            </span>
                          </Link>
                        </div>
                      ))}

                      <div className="step">
                        <Link
                          className="text-decoration-none"
                          to="#"
                          onClick={() =>
                            !user.pin && this.setState({ pin: true })
                          }
                        >
                          Set transaction PIN
                          <span>
                            <svg width="24" height="24" hidden={!user.pin}>
                              <use xlinkHref={iconSprite + "#done"}></use>
                            </svg>
                            <svg width="24" height="24" hidden={user.pin}>
                              <use xlinkHref={iconSprite + "#chevron"}></use>
                            </svg>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        {info && (
          <OnboardInfo
            visible={info}
            onClose={() => this.setState({ info: false })}
          />
        )}
        {!!doc && (
          <OnboardDocs
            visible={!!doc}
            data={doc}
            documents={documents}
            onClose={() => this.setState({ doc: null }, () => this.fetchDocs())}
          />
        )}
        <OnboardBankAccount
          visible={bank}
          onClose={() =>
            this.setState({ bank: false }, () => this.fetchAccounts())
          }
        />
        <Pin
          visible={pin}
          onClose={() => this.setState({ pin: null })}
          onSubmit={(_pin) =>
            this.setState({ pin: null }, () => {
              updateBusiness({ pin: _pin })
                .then((response) => {
                  if (response.status === "success") {
                    this.props.fillUser({ ...user, pin: true });
                  }
                })
                .catch(console.error);
            })
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {},
});

const mapDispatchToProps = {
  fetchBusiness,
  getBanks,
  fillUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(GettingStarted);
